import {useEffect, useState} from "react";
import {useApp} from "../Contex";
import {emptyCache, flushCache, getMenus, removeCache, showCache, updateCache} from "../api/api";
import BottomSheet from "../components/BottomSheet";

export default function Cache(){
    const [cache, setCache] = useState({})
    const [menus, setMenus] = useState([])
    const [flushWarning, setFlushWarning] = useState(false);
    const [emptyWarning, setEmptyWarning] = useState(false);
    const [loading, setLoading] = useState(false)
    const {refresh, permissions:{write}} = useApp()

    function fetchData(){
        showCache().then((ret)=>{
            if(ret.ok){
                setCache(ret.cache)

            }
        })
    }

    function handleFlush(){
        setLoading(true)
        flushCache().then((ret)=>{
            fetchData()
        }).finally(()=> {
                setLoading(false)
                setFlushWarning(false)
            }
        )
    }

    function handleEmpty(){
        setLoading(true)
        emptyCache()
            .then(fetchData)
            .finally(()=>{
            setLoading(false)
            setEmptyWarning(false)
        })


    }

    function handleDelete(id){
        removeCache(id).then((ret)=>{
            fetchData()
        })
    }

    function handleUpdate(id){
        updateCache(id).then((ret)=>{
            fetchData()
        })
    }

    useEffect(()=>{
        fetchData()
    },[refresh])

    useEffect(() => {
        getMenus().then((res)=>{setMenus(res.data)})
    }, []);

    const CacheItem = ({id, object}) => {
        const name = () => {
            if(menus.length > 0){
                const menu = menus.find((item) => item.mnuid === id);
                if(menu){
                    return menu.text
                }
            }
            return `Meny: ${parseInt(id)}`
        }
        return(
            <div className={`card mb-2 p-2 bg-light d-flex justify-content-between flex-row`}>
                <div>
                    <p className="fs-5 fw-bold mb-0">{name()}</p>
                    <p className="mb-0">Artiklar: {object?.length ?? 0}</p>
                </div>
                {write &&
                <div className="d-flex gap-2 align-items-start">
                    <button className="btn btn-outline-secondary" onClick={()=>handleUpdate(id)}>
                        <i className="bi bi-arrow-clockwise"/>
                    </button>
                    <button className="btn btn-outline-danger" onClick={()=>{handleDelete(id)}}>
                        <i className="bi bi-trash"></i>
                    </button>
                </div>
                }
            </div>
        )
    }

    const FlushModal = () => {
        return(<BottomSheet show={flushWarning} setShow={setFlushWarning}>
            {loading?
                <div className="d-flex justify-content-center my-4">
                    <div className="spinner-border text-warning" role="status">
                        <span className="visually-hidden">Laddar...</span>
                    </div>
                </div>
                :
                <div className="text-center">
                    <h3>Vill du ladda om cachen?</h3>
                    <p>Detta kommer ta några sekunder</p>
                    <button className="btn btn-warning" onClick={handleFlush}>Ladda om</button>
                </div>
            }
        </BottomSheet>)
    }

    const EmptyModal = () => {
        return(<BottomSheet show={emptyWarning} setShow={setEmptyWarning}>
            {loading ?
                <div className="d-flex justify-content-center my-4">
                    <div className="spinner-border text-warning" role="status">
                        <span className="visually-hidden">Laddar...</span>
                    </div>
                </div>
            :
                <div className="text-center">
                    <h3>Vill du tömma cachen?</h3>
                    <p>All cachning kommer tas bort.</p>
                    <button className="btn btn-warning" onClick={handleEmpty}>Töm cache</button>
                </div>}
        </BottomSheet>)
    }
    return (<>
            <div className="d-flex align-items-center justify-content-between mb-2">
                <div className="d-flex flex-row align-items-center justify-content-between">
                    <h1>Cache</h1>
                </div>
                {write &&
                    <div className="d-flex gap-2 align-items-center">
                        <button className="btn btn-outline-secondary"
                                onClick={() => setFlushWarning(true)}>
                            <span>Uppdatera </span>
                            <i className="bi bi-arrow-clockwise"></i>
                        </button>
                        <button className="btn btn-outline-danger"
                                onClick={()=>{setEmptyWarning(true)}}>
                            <span>Töm </span>
                            <i className="bi bi-trash"></i>
                        </button>
                    </div>
                }
            </div>
            {Object.keys(cache).map(key => (
                <CacheItem key={key} id={key} object={cache[key]}/>
            ))}
            <FlushModal/>
            <EmptyModal/>
        </>
    )
}
